module.exports = __webpack_public_path__ + "img/main_m.423418df.jpg";